<app-card appearance="outlined">
    <mat-card-header>
        <h5>{{ type }}</h5>
    </mat-card-header>
    <mat-card-content>
        <ng-container [ngTemplateOutlet]="content"></ng-container>
    </mat-card-content>
    <mat-card-actions>
        <ng-container [ngTemplateOutlet]="actions"></ng-container>
    </mat-card-actions>
</app-card>
